var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8335 13.5764V8.41832C12.8335 5.53522 12.8335 4.09367 11.9853 3.73492C11.1371 3.37616 10.1388 4.3955 8.14229 6.43416C7.10836 7.48991 6.51844 7.72369 5.04737 7.72369C3.76085 7.72369 3.1176 7.72369 2.65552 8.03896C1.69632 8.6934 1.84131 9.97256 1.84131 10.9974C1.84131 12.0222 1.69632 13.3013 2.65552 13.9558C3.1176 14.2711 3.76085 14.2711 5.04737 14.2711C6.51844 14.2711 7.10836 14.5049 8.14229 15.5607C10.1388 17.5993 11.1371 18.6187 11.9853 18.2599C12.8335 17.9011 12.8335 16.4595 12.8335 13.5764Z",
    stroke: "#1E1F26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5835 8.25C16.1568 9.00137 16.5002 9.95812 16.5002 11C16.5002 12.0419 16.1568 12.9986 15.5835 13.75",
    stroke: "#1E1F26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 6.41406C19.4801 7.66635 20.1668 9.26095 20.1668 10.9974C20.1668 12.7338 19.4801 14.3285 18.3335 15.5807",
    stroke: "#1E1F26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.9c643d478acf512f4323088a790246e0.svg";
export { ForwardRef as ReactComponent };